<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-model-item label="设备名称">
              <a-input placeholder="请输入设备名称" v-debounce="searchQuery" v-model="queryParam.devName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="是否启用">
              <j-multi-select-tag @change="searchQuery" dictCode="yn" type="checkbox" v-model="queryParam.enabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="计时方式">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="maintaince_timertype"
                type="checkbox"
                v-model="queryParam.tickingType"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="3" :sm="5">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('设备保养计时器')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-button @click="initMaintainceTimer" icon="reload" style="margin-left: 8px">初始化</a-button>

      <a-button @click="initMaintainceTimer" icon="reload" style="margin-left: 8px" v-has="'user:init'">初始化</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="devName" slot-scope="text,record">
          <link-to-detail :id="record.devId" pageType="drawer" route-name="FusionDevice">
            <span>{{text}}</span>
          </link-to-detail>
        </span>
        <span slot="stlSubSlot" slot-scope="text, record">
          <a-tag>{{ record.maintainStl ? `${record.maintainStl.projectName}:\r\n${record.maintainStl.maintenancePlace}-${record.maintainStl.maintenanceOperate}` :'数据错误，请重新同步' }}</a-tag>
        </span>
        <span slot="nextTimeSlot" slot-scope="text, record">
          <a-tag :color="getItemByTime(record)">{{ convertNextTime(record) }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="enable(record)" v-if="record.enabled == 1">停用</a>
          <a @click="enable(record)" v-if="record.enabled == 0">启用</a>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { httpAction, getAction } from '@/api/manage'
  import moment from 'dayjs'

  export default {
    name: 'DevMaintainceTimerList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '设备保养计时器管理页面',
        // 表头
        columns: [
          {
            title: '设备名称',
            align: "center",
            dataIndex: 'devName',
            scopedSlots: { customRender: 'devName' },
            sorter: true,
          },
          {
            title: '保养操作',
            align: "center",
            dataIndex: 'stlSubId',
            scopedSlots: { customRender: 'stlSubSlot' }
          },
          {
            title: '计时方式',
            align: "center",
            dataIndex: 'tickingType_dictText',
            sorter: true,
          },
          {
            title: '下次保养时间',
            align: "center",
            dataIndex: 'nextTime',
            sorter: true,
            scopedSlots: { customRender: 'nextTimeSlot' }
          },
          {
            title: '持续运行时长(分)',
            align: "center",
            dataIndex: 'continuousRunningDuration',
            sorter: true,
          },
          {
            title: '是否启用',
            align: "center",
            dataIndex: 'enabled_dictText',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/maintenance/devMaintainceTimer/list",
          delete: "/maintenance/devMaintainceTimer/delete",
          deleteBatch: "/maintenance/devMaintainceTimer/deleteBatch",
          edit: "/maintenance/devMaintainceTimer/edit",
          exportXlsUrl: "/maintenance/devMaintainceTimer/exportXls",
          importExcelUrl: "maintenance/devMaintainceTimer/importExcel",
          initMaintainceTimer: "/device/devList/initAllDevMainTimer"
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      enable (record) {
        const param = {
          id: record.id,
          enabled: record.enabled == 1 ? 0 : 1
        };
        const that = this;
        httpAction(this.url.edit, param, 'put').then((res) => {
          that.$message.success('修改成功');
        }).finally(() => {
          that.loadData();
        })
      },
      convertNextTime (record) {
        let resStr = '';
        if (record.tickingType === '1') {
          const lastMinutes = Math.max((record.maintenanceIntervals - record.continuousRunningDuration), 0);
          const hours = parseInt(lastMinutes / 60, 10);
          const minutes = lastMinutes % 60;
          resStr = lastMinutes === 0 ? moment().format('YYYY-MM-DD') : `继续运行 【${hours >= 1 ? hours + '小时' : ''}${minutes > 0 ? minutes + '分钟' : ''}】 后`;
        } else {
          resStr = moment().add(record.nextTime, 'minute').format('YYYY-MM-DD');
        }
        return resStr;
      },
      getItemByTime (record) {
        let color = '#52c41a';
        if (record.tickingType === '1') {
          if (record.continuousRunningDuration >= record.maintenanceIntervals) {
            color = '#ff4d4f';
          }
        } else {
          if (record.nextTime < 1440) {
            color = '#ff4d4f';
          } else if (record.nextTime < 1440 * 7) {
            color = '#faad14';
          }
        }
        return color;
      },
      initMaintainceTimer () {
        const that = this;
        this.$confirm({
          title: "确认初始化",
          content: "是否确认初始化保养定时任务配置?这将会重新开始计算保养任务执行时间，本操作不可恢复",
          onOk: function () {
            getAction(that.url.initMaintainceTimer).then((res) => {
              if (res.success) {
                that.$message.success('初始化成功');
                that.loadData();
              } else {
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'Text', value: 'devId', text: '设备标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devName', text: '设备名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'stlSubId', text: '标准库ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tickingType', text: '计时方式', dictCode: '' })
        fieldList.push({ type: 'int', value: 'nextTime', text: '下次保养任务时间', dictCode: '' })
        fieldList.push({ type: 'int', value: 'continuousRunningDuration', text: '上次保养后持续运行时长(分)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'enabled', text: '是否启用', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户标识', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>